import React from 'react'
import SubmitDocuments from '../../../src/components/SubmitDocuments'

export default function DocumentUploadIndex() {
  return (
    <div className="cure-inner-container">
        <SubmitDocuments />
    </div>
  )
}
